module.exports = __webpack_public_path__ + "img/logo.c0b6a751.png";